import React, { ForwardRefExoticComponent } from 'react';

import BaseInput, { InputProps } from '../BaseInput';

export type Props = InputProps;

export const TextInput: ForwardRefExoticComponent<Props> = React.forwardRef(
  (props, ref) => <BaseInput type='text' ref={ref} {...props} />,
);

TextInput.displayName = 'TextInput';
export default TextInput;
